import { SetterOrUpdater } from "recoil"
import { MobergDropdown, MobergDropdownSize } from "../../../Components/MobergDropdown/MobergDropdown"
import React from "react"
import { ECG_SENSITIVITY, EEG_HIGH_FILTERS, EEG_LOW_FILTERS, EEG_NOTCH_FILTERS } from "../../../Pages/Data/Visualize/DataReview/Types/EEG"
import { MobergButton, MobergButtonShape } from "../../../Components/MobergButton/MobergButton"
import { useMobergMenu } from "../../../Hooks/useMobergMenu"
import { MdMoreHoriz } from "react-icons/md"
import { MobergIconSize } from "../../../Components/MobergIcon/MobergIcon"
import { MobergRow } from "../../../Components/MobergLayout/MobergRow"

type EEGMenuOptions = {
    LFF: number
    HFF: number
    notch: number
    ecgSensitivity?: number
}

type EEGCollapseMenuProps<T extends EEGMenuOptions> = {
    eegConfig: T
    setEEGConfig: SetterOrUpdater<T>
    showECGSensitivity?: boolean
}

export const EEGCollapseMenu = <T extends EEGMenuOptions>({ eegConfig, setEEGConfig, showECGSensitivity = false }: EEGCollapseMenuProps<T>) => {
    const { open, MobergMenu } = useMobergMenu({ placement: "bottom" })

    return (<>
        <MobergButton onClick={open} shape={MobergButtonShape.SQUARE}>
            <MdMoreHoriz size={MobergIconSize.SMALL} />
        </MobergButton>

        <MobergMenu style={{ marginTop: "5px", padding: "8px 12px" }}>
            <MobergRow gap="16px">
                <MobergDropdown 
                    label={"LFF"}
                    selectedValue={eegConfig.LFF} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, LFF: parseFloat(value as string) }))}
                    options={Object.entries(EEG_LOW_FILTERS).map(([label, value]) => ({ label, value }))} />
            
                <MobergDropdown 
                    label={"HFF"}
                    selectedValue={eegConfig.HFF} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, HFF: parseFloat(value as string) }))}
                    options={Object.entries(EEG_HIGH_FILTERS).map(([label, value]) => ({ label, value }))} />
            
                <MobergDropdown 
                    label={"Notch"}
                    selectedValue={eegConfig.notch} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, notch: parseFloat(value as string) }))}
                    options={Object.entries(EEG_NOTCH_FILTERS).map(([label, value]) => ({ label, value }))} />

                {showECGSensitivity && (
                    <MobergDropdown
                        label={"ECG Sensitivity"}
                        selectedValue={eegConfig.ecgSensitivity ?? ECG_SENSITIVITY["7 mm/mV"]}
                        size={MobergDropdownSize.SMALL}
                        onChange={value => setEEGConfig(previous => ({ ...previous, ecgSensitivity: parseFloat(value as string) }))}
                        options={Object.entries(ECG_SENSITIVITY).map(([label, value]) => ({ label, value }))}
                    />
                )}
            </MobergRow>
        </MobergMenu>
    </>)
} 
